import { motion, useReducedMotion } from 'motion/react';
import { CheckCircle, Sparkle } from '@phosphor-icons/react';
import { PageHeader } from '../components/PageHeader';
import { RevealOnScroll } from '../components/motion/RevealOnScroll';

const included = [
  'Unlimited follow-ups on every email thread you CC us on',
  'Automatic deadline detection and reminder scheduling',
  'AI-drafted, AI-sent follow-up emails',
  'Full dashboard visibility into every active follow-up',
];

export function PricingPage() {
  const reduce = useReducedMotion();

  return (
    <>
      <PageHeader
        eyebrow="Pricing"
        title="Free, for now"
        subtitle="We’re releasing Chase it for me for free as an experiment for the next 3 months, no credit card, no catch."
      />

      <section className="py-8 pb-24">
        <RevealOnScroll className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-2xl border border-indigo-400/20 bg-indigo-500/[0.08] p-8 sm:p-10">
            <div
              aria-hidden="true"
              className="absolute inset-0 -z-10"
              style={{
                background: 'radial-gradient(ellipse 85% 60% at 50% 0%, rgba(99,102,241,0.25), transparent 65%)',
              }}
            />
            <div className="flex items-center gap-2 text-indigo-300 text-sm font-semibold uppercase tracking-wider">
              <Sparkle weight="fill" className="h-4 w-4" />
              3-month free experiment
            </div>
            <p className="mt-4 text-5xl font-bold text-white">
              $0<span className="text-lg font-medium text-zinc-400">/month</span>
            </p>
            <p className="mt-3 text-zinc-400">
              We want as many people as possible chasing their emails with us while we learn what works.
              Everything is free to use during this trial period.
            </p>

            <ul className="mt-8 space-y-3">
              {included.map((item) => (
                <li key={item} className="flex items-start gap-3 text-zinc-300">
                  <CheckCircle weight="fill" className="h-5 w-5 mt-0.5 flex-none text-indigo-400" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <motion.a
              href="/app"
              whileHover={reduce ? undefined : { scale: 1.03 }}
              whileTap={reduce ? undefined : { scale: 0.97 }}
              className="mt-8 block w-full text-center px-8 py-3 bg-indigo-600 text-white rounded-lg text-lg font-semibold hover:bg-indigo-500 transition-colors shadow-lg shadow-indigo-600/30"
            >
              Get Started
            </motion.a>
          </div>

          <p className="mt-6 text-center text-sm text-zinc-500">
            After the experiment ends we’ll introduce paid plans, and we’ll give everyone plenty of notice
            before anything changes.
          </p>
        </RevealOnScroll>
      </section>
    </>
  );
}
